import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';

import { Message } from 'semantic-ui-react';
import {
  ReduxFormMaterialTextField,
  ReduxFormMaterialSelect,
  ReduxFormMaterialSwitch,
  Loading,
  Button
} from 'components';

import * as commonVar from 'libs/commonVar';
import * as common from 'libs/commonFunc';

import classNames from 'classnames/bind';
import styles from './TargetEdit.css';
const cx = classNames.bind(styles);

class TargetEdit extends PureComponent {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    // 모달의 onOpen 이벤트 대용
    const { handleOnOpenEditModal } = this.props;

    handleOnOpenEditModal();
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const {
      addMode,
      isAuth,
      onProgress,
      errorMessage,
      targetInfo,
      handleUserEmailReSend,
      handleUserEmailCancel
    } = this.props;
    const { userNo, userNewEmail, passwdUpdateEpoch, regEpoch } = targetInfo;

    const serviceNoErrorMsg = errorMessage && errorMessage.errInfo ? defineMessages(formatMessage({ id: 'ModalTargetAdd_10', defaultMessage: '잘못된 서비스 번호입니다.' })) : '';
    const emailErrorMsg = errorMessage && errorMessage.result ? defineMessages(formatMessage({ id: 'ModalTargetAdd_11', defaultMessage: '이미 등록된 이메일입니다.' })) : '';

    return (
      <div className={cx('template-edit-box')}>
        <Loading
          active={onProgress}
          size="small"
          content={defineMessages(formatMessage({ id: 'UserEdit_1', defaultMessage: '처리 중...' }))}
        />
        <div className={cx('template-edit-section')}>
          <span className={cx('materialTextField-title')}>
            {defineMessages(formatMessage({ id: 'ModalTargetAdd_3', defaultMessage: '이름' }))}
          </span>
          <ReduxFormMaterialTextField
            className={cx('input-gap', 'input-area')}
            required
            fullWidth
            name="targetName"
            checkType={101}
            validate={['required', 'targetName']}
          />
          {isAuth === 2 &&
            <div>
              <span className={cx('materialTextField-title')}>
                {defineMessages(formatMessage({ id: 'ModalTargetAdd_9', defaultMessage: '대상 서비스 번호' }))}
              </span>
              <ReduxFormMaterialTextField
                className={cx('input-gap', 'input-area')}
                required
                fullWidth
                name="serviceNo"
                errorText={serviceNoErrorMsg}
                checkType={101}
                validate={['required', 'number']}
                error={serviceNoErrorMsg ? true : false}
              />
            </div>
          }
          <span className={cx('materialTextField-title')}>
            {defineMessages(formatMessage({ id: 'ModalTargetAdd_4', defaultMessage: '이메일' }))}
          </span>
          <ReduxFormMaterialTextField
            className={cx('input-gap', 'input-area', { 'change-email': userNewEmail })}
            required
            fullWidth
            // label={defineMessages(formatMessage({ id: 'UserEdit_5', defaultMessage: '이메일' }))}
            // helperText={emailHelperText}
            errorText={emailErrorMsg}
            name="targetEmail"
            checkType={101}
            validate={['required', 'email']}
            error={emailErrorMsg ? true : false}
          // warn={['email']}
          />
          {/* autocomplete 되는 것을 방지하기 위해 input 추가 */}
          <span className={cx('materialTextField-title')}>
            {defineMessages(formatMessage({ id: 'ModalTargetAdd_5', defaultMessage: '연락처' }))}
          </span>
          <ReduxFormMaterialTextField
            className={cx('input-gap', 'input-area')}
            fullWidth
            name="targetPhone"
            checkType={101}
            validate={['userPhone']}
          />
          <span className={cx('materialTextField-title')}>
            {defineMessages(formatMessage({ id: 'ModalTargetAdd_6', defaultMessage: '소속' }))}
          </span>
          <ReduxFormMaterialTextField
            className={cx('input-gap', 'input-area')}
            fullWidth
            name="targetDivision"
            checkType={101}
            validate={['targetDivision']}
          />
          <span className={cx('materialTextField-title')}>
            {defineMessages(formatMessage({ id: 'ModalTargetAdd_7', defaultMessage: '직급' }))}
          </span>
          <ReduxFormMaterialTextField
            className={cx('input-gap', 'input-area')}
            fullWidth
            name="targetPosition"
            checkType={101}
            validate={['targetPosition']}
          />
          <span className={cx('materialTextField-title')}>
            {defineMessages(formatMessage({ id: 'TargetDetail_5', defaultMessage: '메모' }))}
          </span>
          <ReduxFormMaterialTextField
            className={cx('input-gap', 'input-area', 'text-area')}
            fullWidth
            name="targetDetail"
            checkType={101}
            multiline
            rows={3}
            validate={['targetPosition']}
          />
        </div>
      </div>
    );
  }
}

TargetEdit.propTypes = {
  //
  targetInfo: PropTypes.object
};
TargetEdit.defaultProps = {
  //
  targetInfo: {}
};

export default injectIntl(TargetEdit);



// WEBPACK FOOTER //
// ./src/script/components/target/TargetEdit.js